import * as React from 'react';
import { NewsArticleFieldsFragment } from '../../../@types/generated';
import { centeredMainGridClasses } from '@/styles/grid';
import TagLabel from 'components/src/label';
import { Heading, Paragraph, Label } from 'components/src/typography';
import Image from 'next/image';
import { getOr } from '@/utils/options';
import { ImageWithFocalPoint } from '../ImageWithFocalPoint';
import SocialMedia from './SocialMedia';
import { monthName } from '@/utils/dates';
import RichTextContainer from './RichTextContainer';

type Props = {
  data: NewsArticleFieldsFragment;
};

const NewsArticle = ({ data }: Props) => {
  const publishedDate = data.publishedDate ? new Date(data.publishedDate) : null;

  return (
    <div className={`${centeredMainGridClasses}`}>
      <div className="col-span-full mb-32 flex justify-center gap-8">
        {data?.tagsCollection?.items.map((tag) => {
          return tag?.title && <TagLabel key={tag.id} label={tag.title} type="pill" colorVariant="red" />;
        })}
      </div>
      <div className="col-span-full mb-40 text-center lg:col-span-8 lg:col-start-3">
        {data.title && <Heading variant="medium">{data.title}</Heading>}
        {data.description && <Paragraph classes="mt-16 text-black-100">{data.description}</Paragraph>}
        <div className="mt-24 flex justify-center gap-x-16">
          {data.authorImage?.url && (
            <Image
              src={data.authorImage.url}
              alt={getOr(data.authorImage.title, '')}
              height={40}
              width={40}
              style={{ borderRadius: '50%' }}
            />
          )}
          <div className="grid self-center text-left">
            {data.authorName && <Label classes="text-black-75">{data.authorName}</Label>}
            {publishedDate && (
              <Paragraph variant="small" classes="text-black-75">{`${publishedDate.getUTCDate()}. ${monthName(
                publishedDate
              )} ${publishedDate.getUTCFullYear()}`}</Paragraph>
            )}
          </div>
        </div>
      </div>
      {data.heroImage && (
        <div className="relative col-span-full mb-24 h-[600px] md:mb-64">
          <ImageWithFocalPoint image={data.heroImage} sectionId={data.heroImage.id} className="rounded-28" />
        </div>
      )}
      <div className="col-span-1 hidden h-fit text-center lg:grid">
        <SocialMedia title={getOr(data.title, '')} />
      </div>
      <div className={`col-span-full grid  grid-cols-10 gap-24 lg:col-span-10`}>
        <RichTextContainer data={data} />
      </div>
      <div className="col-span-full mt-32 grid justify-center text-center lg:hidden">
        <SocialMedia title={getOr(data.title, '')} />
      </div>
    </div>
  );
};
export default NewsArticle;
